<div class="d-flex my-2 align-items-center">
  <label class="me-2 label"><strong>{{label}}</strong></label>
  <ng-select
    [multiple]="true"
    [items]="options"
    [(ngModel)]="selected"
    (change)="onChange($event)"/>
</div>
